import React from 'react';
import { View, Text, ImageBackground, TouchableOpacity, StyleSheet } from 'react-native';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'
// import RNOtpVerify from 'react-native-otp-verify';
// import SmsRetriever from 'react-native-sms-retriever';
// import SmsListener from 'react-native-android-sms-listener'
import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation } from '@react-navigation/native';
import http from '../../utils/http';
import { formatCurrency } from '../../utils/money';

const WalletNavCard = () => {
    const navigation = useNavigation()
    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [isLoading, setLoading] = React.useState(false)
    const [balance, setBalance] = React.useState(null)

    const loadBalance = () => {
        let form = new FormData()
        form.append('mobile', buyer.phone)
        form.append('model', 'buyer')
        http.post('spend/eyowo_retrieve_balance', form, token)
            .then(res => {
                if (res.code === 200) setBalance(res?.data?.data?.user?.balance)
            })
            .catch(err => {
                console.warn(err)
            })
    }

    // const startListeningForOtp = () =>
    //     RNOtpVerify.getOtp()
    //         .then(p => {
    //             console.log(p, 'listening...')
    //             RNOtpVerify.addListener(otpHandler)
    //         })
    //         .catch(p => console.log(p, 'rn-verify-otp'));

    // const otpHandler = (message) => {
    //     const otp = /(\d{4})/g.exec(message)[1];
    //     console.log(message)
    //     RNOtpVerify.removeListener();
    //     Keyboard.dismiss();
    // }

    // Get the SMS message (second gif)
    const startRetrieving = async () => {
        try {
            // const registered = await SmsRetriever.startSmsRetriever();
            // if (registered) {
            //     console.log('registered listener')
            //     SmsRetriever.addSmsListener(event => {
            //         console.log('got a message', event);
            //         // console.log(event.message);
            //         // SmsRetriever.removeSmsListener();
            //     });
            // } else {
            //     console.log('failed to register listener')
            // }
        } catch (error) {
            console.log(JSON.stringify(error));
        }

        // try {
        //     const phoneNumber = await SmsRetriever.requestPhoneNumber();
        //     // console.log(phoneNumber)
        //     Alert.alert(phoneNumber)
        // } catch (error) {
        //     console.log(JSON.stringify(error));
        // }
    };

    const startListening = () => {
        let subscription = SmsListener.addListener(message => {
            console.log(message)
            // let verificationCodeRegex = /Your verification code: ([\d]{6})/

            // if (verificationCodeRegex.test(message.body)) {
            //     let verificationCode = message.body.match(verificationCodeRegex)[1]

            //     YourPhoneVerificationApi.verifyPhoneNumber(
            //         message.originatingAddress,
            //         verificationCode
            //     ).then(verifiedSuccessfully => {
            //         if (verifiedSuccessfully) {
            //             subscription.remove()
            //             return
            //         }

            //         if (__DEV__) {
            //             console.info(
            //                 'Failed to verify phone `%s` using code `%s`',
            //                 message.originatingAddress,
            //                 verificationCode
            //             )
            //         }
            //     })
            // }
        })

        return subscription

    }

    React.useEffect(() => {
        //
        // startListeningForOtp()
        // startRetrieving()
        // let subscription = startListening()
        loadBalance()
        return () => {
            // RNOtpVerify.removeListener()
            // SmsRetriever.removeSmsListener()
            // subscription.remove()
        };
    }, []);


    return <>
        <View style={{
            width: '100%',
            height: 140,
            position: 'absolute',
            backgroundColor: Colors.tintColor,
            top: -58
        }}></View>
        <View style={styles.container}>
            {/* card */}
            <View style={styles.card}>
                {/* card header */}
                <View style={styles.cardHeader}>
                    <Text style={[
                        styles.cardHeaderTitle,
                        FontStyles.normal,
                        FontStyles.size14,
                        FontStyles.lh16,
                        FontStyles.gray
                    ]}>My Balance</Text>
                    {
                        balance !== null ? <Text style={[
                            styles.balanceBadge,
                            FontStyles.size14,
                            FontStyles.lh16,
                        ]}>{formatCurrency(balance/100)}</Text> : null
                    }
                </View>

                {/* card body */}
                <View style={styles.navContainer}>
                    {/* fund account */}
                    <TouchableOpacity style={styles.navItem} onPress={()=>navigation.navigate('WalletAccount')}>
                        <ImageBackground
                            resizeMode="contain"
                            source={require('../../assets/images/main/wallet-fund-account.png')}
                            style={{ width: 48, height: undefined, aspectRatio: 1 }} />
                        <Text
                            style={[
                                FontStyles.normal,
                                FontStyles.size13,
                                FontStyles.lh16,
                                FontStyles.dark,
                                {
                                    textAlign: 'center',
                                    marginTop: 8,
                                }
                            ]}
                        >Fund{"\n"}Account</Text>
                    </TouchableOpacity>

                    {/* buy airtime */}
                    <TouchableOpacity style={styles.navItem} onPress={()=>navigation.navigate('WalletAirtime')}>
                        <ImageBackground
                            resizeMode="contain"
                            source={require('../../assets/images/main/wallet-buy-airtime.png')}
                            style={{ width: 48, height: undefined, aspectRatio: 1 }} />
                        <Text
                            style={[
                                FontStyles.normal,
                                FontStyles.size13,
                                FontStyles.lh16,
                                FontStyles.dark,
                                {
                                    textAlign: 'center',
                                    marginTop: 8,
                                }
                            ]}
                        >Buy{"\n"}Airtime</Text>
                    </TouchableOpacity>

                    {/* send money */}
                    <TouchableOpacity style={styles.navItem} onPress={()=>navigation.navigate('WalletSendStart')}>
                        <ImageBackground
                            resizeMode="contain"
                            source={require('../../assets/images/main/wallet-send-money.png')}
                            style={{ width: 48, height: undefined, aspectRatio: 1 }} />
                        <Text
                            style={[
                                FontStyles.normal,
                                FontStyles.size13,
                                FontStyles.lh16,
                                FontStyles.dark,
                                {
                                    textAlign: 'center',
                                    marginTop: 8,
                                }
                            ]}
                        >Send{"\n"}Money</Text>
                    </TouchableOpacity>

                    {/* request loan */}
                    <TouchableOpacity style={[styles.navItem, { opacity: 0.4 }]} disabled={true}>
                        <ImageBackground
                            resizeMode="contain"
                            source={require('../../assets/images/main/wallet-request-loan.png')}
                            style={{ width: 48, height: undefined, aspectRatio: 1 }} />
                        <Text
                            style={[
                                FontStyles.normal,
                                FontStyles.size13,
                                FontStyles.lh16,
                                FontStyles.dark,
                                {
                                    textAlign: 'center',
                                    marginTop: 8,
                                }
                            ]}
                        >Request{"\n"}Loan</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </View >
    </>
}

export default WalletNavCard

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        paddingTop: 8,
    },
    card: {
        backgroundColor: Colors.whiteColor,
        overflow: 'hidden',
        borderRadius: 6,
        borderColor: Colors.borderColor,
        borderWidth: 1,
        borderBottomWidth: 3,
        borderStyle: 'solid',
    },
    cardHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderBottomWidth: 1,
        borderColor: Colors.borderColor,
        borderStyle: 'solid'
    },
    cardHeaderTitle: {},
    balanceBadge: {
        color: Colors.successText,
        backgroundColor: Colors.successBackground,
        borderRadius: 4,
        paddingHorizontal: 8,
        paddingVertical: 6,
    },
    navContainer: {
        paddingVertical: 10,
        paddingHorizontal: 8,
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    navItem: {
        width: '25%',
        alignItems: 'center',
        paddingHorizontal: 8,
        paddingVertical: 10,
    }
})